/*
 * @Author: your name
 * @Date: 2021-03-30 10:30:04
 * @LastEditTime: 2021-05-14 09:19:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\settled.js
 */
export default [
    {
        path: '/ticket/search',
        component: resolve => require(['../../views/ticket/search.vue'], resolve),
        meta: { title: '机票查询' }
    },
    {
        path: '/ticket/orderBook',
        name:'ticketOrderBook',
        component: resolve => require(['../../views/ticket/orderBook.vue'], resolve),
        meta: { title: '机票预订' }
    },
    {
        path: '/ticket/airticketorder',
        component: resolve => require(['../../views/ticket/airticketorder-list.vue'], resolve),
        meta: { title: '机票订单' }
    },
    {
        path: '/ticket/detail',
        component: resolve => require(['../../views/ticket/ticket-order-detail'], resolve),
        meta: { title: '机票订单详情' }
    },
    {
        path: '/ticket/payment',
        component: resolve => require(['../../views/ticket/payment'], resolve),
        meta: { title: '机票付款' }
    },
    {
        path: '/ticket/change',
        component: resolve => require(['../../views/ticket/ticket-change'], resolve),
        meta: { title: '机票改签' }
    },
    {
        path: '/ticket/refund',
        component: resolve => require(['../../views/ticket/ticket-refund'], resolve),
        meta: { title: '机票退签' }
    },
    {
        path: '/ticket/goldenBeanFlow',
        component: resolve => require(['../../views/ticket/golden-bean-flow'], resolve),
        meta: { title: 'J豆流水/账户信息' }
    },


    

    
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/ticket.js